module.exports = __webpack_public_path__ + "static/media/Festival1.9c8e2589.png";